import * as React from 'react';
import { cn } from '@/lib/utils';

const FilterAlert = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-0 flex max-w-full items-center gap-3 rounded-md bg-white p-3 text-neutral-dark shadow-dropshadow', className)}
    {...props}
  />
));
FilterAlert.displayName = 'FilterAlert';

const FilterAlertIcon = React.forwardRef(({ className, variant = 'danger', ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      // styles
      'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-danger text-white [&>svg]:min-w-[20px]',
      variant === 'danger' && 'bg-danger',
      variant === 'warning' && 'bg-warning',
      className
    )}
    {...props}
  />
));
FilterAlertIcon.displayName = 'FilterAlertIcon';

export { FilterAlert, FilterAlertIcon };
